export { default } from "./StudentComponent";
